import styled from 'styled-components';
export const PlaylistNewBannerStyle = styled.div`
  display: flex;
  padding: 24px 30px;
  background: transparent;
  flex-direction: column;

  color: ${props => props.theme.colors.primary};
  font-weight: 500;

  @media (max-width: 1600px) {
    padding: 20px 24px;
  }

  @media (max-width: 1400px) {
    padding: 16px 20px;
  }

  @media (max-width: 1024px) {
    padding: 16px 20px;
  }

  .fixIcon {
    width: 14px !important;
  }
  .bannerDiv {
    transition: 2s;
    @media screen and (min-width: 768px) {
      min-height: auto;
    }
  }
  .hidebanner {
    opacity: 0;
    overflow: hidden;
    animation: reduceHeight 0.5s;
  }

  @keyframes reduceHeight {
    0% {
      height: 420px !important;
    }

    100% {
      height: 0px !important;
    }
  }

  @keyframes floatUpDown {
    0%, 100% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-10px);
    }
  }

  .platform {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    margin-top: 5px;

    @media (max-width: 1400px) {
      margin-bottom: 2px;
      margin-top: 2px;
    }
  }
  .platform img {
    width: 80px;
    margin-bottom: 0px;
    margin-right: 0px;
    object-fit: contain;

    @media (max-width: 1600px) {
      width: 70px;
    }

    @media (max-width: 1400px) {
      width: 65px;
    }

    @media (max-width: 1024px) {
      width: 60px;
    }
  }
  .images1 {
    height: 24px;
    width: 22px;
  }
  .row1 {
    display: flex;
    align-items: center;
    gap: 8px;

    @media (max-width: 1400px) {
      gap: 6px;
    }
  }
  .p1 {
    margin-left: 0px;
    font-size: 13px;
    font-weight: 500;
    opacity: 0.8;
    text-transform: uppercase;
    letter-spacing: 0.5px;

    @media (max-width: 1400px) {
      font-size: 12px;
    }
  }

  .scheduledBadge {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 4px 10px;
    background: #3b82f6f2;
    border: none;
    border-radius: 10px;
    font-size: 10px;
    font-weight: 600;
    color: #fff;
    letter-spacing: 0.3px;
    white-space: nowrap;
    cursor: pointer;
    transition: all 0.2s ease;

    img {
      filter: brightness(0) invert(1);
      flex-shrink: 0;
    }

    svg {
      flex-shrink: 0;

      path {
        fill: #fff;
      }
    }

    span {
      white-space: nowrap;
    }

    &:hover {
      background: #4f94f9;
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
    }

    &:active {
      transform: translateY(0);
    }

    @media (max-width: 1024px) {
      padding: 3px 8px;
      font-size: 9px;
      gap: 4px;
    }

    &.scheduledBadgeReset {
      background: #a855f7f2;

      &:hover {
        background: #b76ff8;
        box-shadow: 0 4px 12px rgba(168, 85, 247, 0.3);
      }

      svg path {
        fill: #fff;
      }

      .fixIcon path {
        fill: #fff;
      }
    }
  }
  .row-space {
    display: flex;
    justify-content: space-between;
  }
  #btn12 {
    padding: 10px;
    height: 50px;
    margin-right: 30px;
    border: white;
    background: #181818;
  }

  .container {
    display: flex;
    gap: 40px;
    width: 100%;

    align-items: flex-start;
    justify-content: space-between;

    @media (max-width: 1600px) {
      gap: 32px;
    }

    @media (max-width: 1400px) {
      gap: 20px;
    }

    @media (max-width: 1024px) {
      gap: 24px;
    }

    @media only screen and (max-width: 600px) {
      margin: auto;
      width: 100%;
      align-items: center;
      flex-direction: column-reverse;
      gap: 24px;
    }
  }

  .image {
    width: 220px;
    box-shadow: 0px 6px 32px 6px rgba(0, 0, 0, 0.2);
  }

  .text-container {
    display: flex;
    flex-direction: column;
    padding-bottom: 0px;
    font-size: 20px;
    flex: 1;
    margin-left: 0%;
    margin-bottom: 0px;
    min-width: 0;
  }

  .title {
    color: ${props => props.theme.colors.primary};
    font-family: Poppins;
    font-size: 48px;
    font-weight: 700;
    line-height: 1.1;
    margin-bottom: 4px;
    padding-bottom: 4px;
    margin-top: 0;

    letter-spacing: -0.02em;
    text-align: left;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    display: -webkit-box;

    @media (max-width: 1600px) {
      font-size: 36px;
    }

    @media (max-width: 1400px) {
      font-size: 28px;
      margin-bottom: 4px;
      line-height: 1;
    }

    @media (max-width: 1024px) {
      font-size: 28px;
    }

    @media (max-width: 768px) {
      font-size: 24px;
    }
  }
  .desc {
    color: ${props => props.theme.colors.primary};
    font-family: Poppins;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.4;
    letter-spacing: -0.01em;
    text-align: left;
    margin-bottom: 10px;
    opacity: 0.85;
    max-width: 90%;

    @media (max-width: 1600px) {
      font-size: 13px;
      margin-bottom: 8px;
    }

    @media (max-width: 1400px) {
      font-size: 11px;
      margin-bottom: 4px;
      line-height: 1.3;
    }

    @media (max-width: 1024px) {
      font-size: 11px;
      margin-bottom: 6px;
    }
  }

  .p1 {
    font-size: 20px;
  }

  .p2 {
    display: flex;

    margin-top: 0px;
    margin-bottom: 14px;
    font-family: Poppins;
    color: ${props => props.theme.colors.primary};
    font-size: 13px;
    font-weight: 500;
    line-height: 1.4;
    letter-spacing: -0.01em;
    text-align: left;
    align-items: center;

    @media (max-width: 1400px) {
      font-size: 11px;
      margin-bottom: 8px;
      margin-top: -2px;
    }

    @media (max-width: 1024px) {
      font-size: 11px;
      margin-bottom: 10px;
    }
  }

  .p2 span {
    margin: 0px 8px;
  }
  .p2 .platForm {
    opacity: 0.75;
    font-family: Poppins;
    font-size: 13px;
    font-weight: 400;
    line-height: 1.4;
    letter-spacing: -0.01em;
    text-align: left;
  }
  .row-space {
    flex-direction: row;
  }

  .pre-release {
    font-size: inherit;
  }
  .songPlayListButtons {
    display: flex;
    align-items: center;
    gap: 4px;

    margin-top: 0px;
    flex-wrap: wrap;

    @media (max-width: 1400px) {
      gap: 3px;
    }

    @media (max-width: 1280px) {
      gap: 6px;
    }

    @media (max-width: 1280px) {
      gap: 6px;
    }

    @media only screen and (max-width: 600px) {
      justify-content: space-between;
      width: 100%;
      margin: 20px 0px;
    }
  }
  .songPlayListButtons .addSong {
    display: flex;
    align-items: center;
    justify-content: center;

    background: #007aff;
    padding: 0px 28px;
    height: 46px;

    font-family: Poppins;
    font-size: 14px;
    font-weight: 600;
    line-height: 1;
    letter-spacing: -0.01em;
    text-align: center;
    border-radius: 23px;
    border: none;
    color: #fff;

    margin-right: 8px;

    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 2px 12px rgba(0, 122, 255, 0.3);

    @media (max-width: 1600px) {
      padding: 0px 20px;
      height: 42px;
      font-size: 13px;
    }

    @media (max-width: 1400px) {
      padding: 0px 14px;
      height: 34px;
      font-size: 12px;
      margin-right: 6px;
    }

    @media (max-width: 1024px) {
      padding: 0px 16px;
      height: 36px;
      font-size: 12px;
    }

    &:hover {
      background: #0056cc;
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(0, 122, 255, 0.4);
    }

    &:active {
      transform: translateY(0px);
      box-shadow: 0 2px 8px rgba(0, 122, 255, 0.25);
    }
  }
  .songPlayListButtons .addSong svg {
    margin-right: 10px;
    width: 16px;
    height: 16px;

    @media (max-width: 1024px) {
      width: 14px;
      height: 14px;
      margin-right: 8px;
    }
  }
  .songPlayListButtons .iconButton {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #1a1d24;
    border: 2px solid #2a2d35;
    border-radius: 14px;
    padding: 0;
    height: 48px;
    width: 48px;
    margin-right: 0px;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(135deg, #007aff 0%, #0056cc 100%);
      opacity: 0;
      transition: opacity 0.3s ease;
      z-index: 0;
    }

    @media (max-width: 1600px) {
      height: 44px;
      width: 44px;
    }

    @media (max-width: 1400px) {
      height: 36px;
      width: 36px;
      border-radius: 11px;
    }

    @media (max-width: 1024px) {
      height: 38px;
      width: 38px;
      border-radius: 12px;
    }

    img {
      width: 22px;
      height: 22px;
      object-fit: contain;
      opacity: 0.75;
      transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
      position: relative;
      z-index: 1;
      filter: brightness(1.2);

      @media (max-width: 1400px) {
        width: 20px;
        height: 20px;
      }

      @media (max-width: 1024px) {
        width: 18px;
        height: 18px;
      }
    }

    &:hover {
      border-color: #007aff;
      transform: translateY(-3px) scale(1.05);
      box-shadow: 0 8px 24px rgba(0, 122, 255, 0.35);
      
      &::before {
        opacity: 0.15;
      }
      
      img {
        opacity: 1;
        transform: scale(1.15) rotate(-5deg);
        filter: brightness(1.5) drop-shadow(0 0 8px rgba(0, 122, 255, 0.6));
      }
    }

    &:active {
      transform: translateY(-1px) scale(1.02);
      box-shadow: 0 4px 12px rgba(0, 122, 255, 0.25);
    }
  }
  .songPlayListButtons .iconButtonSvg {
    svg {
      width: 22px !important;
      height: 22px !important;
      opacity: 0.75;
      transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
      position: relative;
      z-index: 1;
      filter: brightness(1.2);

      @media (max-width: 1400px) {
        width: 20px !important;
        height: 20px !important;
      }

      @media (max-width: 1024px) {
        width: 18px !important;
        height: 18px !important;
      }
    }

    &:hover svg {
      opacity: 1;
      transform: scale(1.15) rotate(-5deg);
      filter: brightness(1.5) drop-shadow(0 0 8px rgba(0, 122, 255, 0.6));
    }
  }

  .songPlayListButtons .iconButtonSvgReset {
    svg {
      width: 28px !important;
      height: 28px !important;
      opacity: 0.75;
      transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
      position: relative;
      z-index: 1;
      filter: brightness(1.2);

      @media (max-width: 1400px) {
        width: 24px !important;
        height: 24px !important;
      }

      @media (max-width: 1024px) {
        width: 20px !important;
        height: 20px !important;
      }
    }

    &:hover svg {
      opacity: 1;
      transform: scale(1.15) rotate(-5deg);
      filter: brightness(1.5) drop-shadow(0 0 8px rgba(0, 122, 255, 0.6));
    }
  }

  .songPlayListButtons .editPlaylist {
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    padding: 0px 15;
    height: 33px;
    font-family: Poppins;
    font-size: 10px;
    font-weight: 500;
    line-height: 21px;
    letter-spacing: 0em;
    text-align: center;
    margin-right: 12px;
    cursor: pointer;
    position: relative;

    background: #242A34;
    border-radius: 8px;
    border: none;
    border: 1px solid #ffffff33;
    padding: 10px 20px;
    min-width: 142px;
  }
  .songPlayListButtons .editPlaylist svg {
    margin-right: 5px;
    width: 12px;

    // width:;
    // height:;
  }
  .playListPic {
    height: 240px;
    width: 240px;
    border-radius: 16px;
    display: flex;
    background: linear-gradient(135deg, #242429 0%, #1a1a1f 100%);
    align-items: center;
    overflow: hidden;
    justify-content: center;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    flex-shrink: 0;
    transform-style: preserve-3d;
    transform-origin: center center;

    @media (max-width: 1600px) {
      height: 200px;
      width: 200px;
    }

    @media (max-width: 1400px) {
      height: 150px;
      width: 150px;
    }

    @media (max-width: 1024px) {
      height: 160px;
      width: 160px;
    }

    @media (max-width: 768px) {
      height: 160px;
      width: 160px;
    }

    &:hover {
      box-shadow: 0 12px 48px rgba(0, 0, 0, 0.5);
    }
  }
  .playlistIcon {
    font-size: 96px;
    color: rgba(255, 255, 255, 0.1);
    transition: transform 0.3s ease;
  }
  .playListPic img {
    width: 100%;
    object-fit: cover;
    height: 100%;
    transition: transform 0.3s ease;
  }
  .lastStatus {
    p {
      color: #fff;
      opacity: 0.7;
      font-size: 12px;
      margin: 0px;
    }
  }
  .playListPic .upcoming {
    transform: rotate(-90deg);
    height: 67.71px;
    white-space: nowrap;
    right: -24px;
    position: absolute;
    height: 67.71px;
    display: flex;
    align-items: center;

    font-family: Poppins;
    font-size: 24px;
    font-weight: 500;
    line-height: 36px;
    letter-spacing: 0.02em;
    text-align: center;
  }
  .playlistActions {
    display: flex;
    margin-bottom: 4px;
    justify-content: space-between;
    align-items: center;

    @media (max-width: 1400px) {
      margin-bottom: 2px;
    }

    .innerPlaylistActions {
      display: flex;
      align-items: center;
      gap: 16px;

      @media (max-width: 1400px) {
        gap: 12px;
      }
    }
  }
  .playlistActions .actionDiv {
    display: flex;
    align-items: center;
    position: relative;
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 8px;
    padding: 6px 12px;
    transition: all 0.2s ease;

    @media (max-width: 1400px) {
      padding: 5px 10px;
      border-radius: 6px;
    }

    &:hover {
      background: rgba(255, 255, 255, 0.05);
      border-color: rgba(255, 255, 255, 0.12);
    }
  }
  .playlistActions .actionDiv p {
    display: flex;
    align-items: center;
    margin-right: 0px;
    margin-bottom: 0;
  }
  .playlistActions .actionDiv .text {
    font-size: 11px important;
  }
  .playlistActions .actionDiv p .textAction {
    font-family: Poppins;
    font-size: 11px;
    font-weight: 500;
    line-height: 1;
    letter-spacing: 0.01em;
    text-align: left;
    opacity: 0.8;
    margin-right: 8px;
    white-space: nowrap;

    @media (max-width: 1400px) {
      font-size: 10px;
      margin-right: 6px;
    }
  }
  .playlistActions .actionDiv p span {
    font-family: Poppins;
    font-size: 22px;
    font-weight: 500;
    line-height: 33px;
    letter-spacing: 0.04em;
    text-align: left;
  }

  @media only screen and (max-width: 900px) {
    padding: 10px;
    .playlistActions {
      white-space: nowrap;
      width: 100%;
      overflow-x: auto;
      overflow-y: hidden;
      margin-bottom: 10px;

      &::-webkit-scrollbar {
        width: 3px;
        height: 2px !important;
      }

      &::-webkit-scrollbar-track {
        background: #f1f1f1;
      }

      &::-webkit-scrollbar-thumb {
        background: #888 !important;
      }

      &::-webkit-scrollbar-thumb:hover {
        background: #555;
      }
    }
  }
  @media only screen and (max-width: 600px) {
    .text-container {
      padding-bottom: 0px !important;
      margin-bottom: 0px !important;
      width: 100%;

      display: flex;
      flex-direction: column;
    }
    .playListPic {
      width: 100%;
    }
    .images1 {
      height: 16px !important;
      width: 16px !important;
    }

    .p1 {
      font-size: 14px;
    }

    .p2 {
      font-size: 14px;
    }

    .row-space {
      flex-direction: column;
    }

    .title {
      // font-size: 14px;
      margin: 4px 0px;
      font-size: 28px !important;
      line-height: initial;
    }

    #btn12 {
      padding: 8px;
      height: 40px;
      margin-right: 90px;
    }

    .pre-release {
      font-size: 12px;
    }

    .spanner {
      padding: 0px 0px !important;
    }

    .icons {
      font-size: 14px;
    }
    .platform {
      margin-bottom: 3px;
      margin-top: 3px;
    }
  }

  @media only screen and (max-width: 375px) {
    .spanner {
      padding: 0px 0px !important;
    }
  }
  @media only screen and (max-width: 320px) {
    #btn12 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
    }
  }
  .playListbannerSmall {
    display: none;
    .visible {
      display: block;
    }
    .playListPic {
      width: 100px;
      aspect-ratio: 1;
      height: 100px;
      margin-right: 10px;
    }
    .playListDetail {
      display: flex;
      align-items: center;
      h1 {
        font-size: 16px;
        line-height: unset !important;
      }
      p {
        line-height: unset !important;
        font-size: 14px;
      }
      .textDetail {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;
      }
    }
  }
  .footer {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .yesNoButtons {
      display: flex;
      gap: 12px;
      align-items: center;
    }

    p {
      color: #fff;
      opacity: 0.7;
      font-size: 12px;
      margin: 0px;
    }
  }
`;
